// src/components/Fields/AssetTypeFieldPreview.jsx
import React from 'react';
import { Typography, Box } from '@mui/material';
import CategoryIcon from '@mui/icons-material/Category'; // or any icon you like
import DraggablePreviewWrapper from './DraggablePreviewWrapper';
import { useFormLayout } from '../../contexts/FormLayoutContext';

const AssetTypeFieldPreview = ({ id, index }) => {
  const { showDropZones, setShowDropZones } = useFormLayout();

  // Optional debug – keep if useful
  try {
    setShowDropZones && setShowDropZones.toString();
//    console.log(
//      '[AssetTypeFieldPreview] setShowDropZones function definition:',
//      setShowDropZones.toString(),
//    );
  } catch (error) {
    console.error(
      '[AssetTypeFieldPreview] Error logging setShowDropZones function definition:',
      error,
    );
  }

  return (
    <DraggablePreviewWrapper
      id={id}
      // 🔴 KEY CHANGE: use the custom field type here
      type="asset-type"
      index={index}
      isNew={true}
      showDropZones={showDropZones}
      setShowDropZones={setShowDropZones}
    >
      <Box display="flex" alignItems="center">
        <CategoryIcon
          sx={{
            fontSize: '0.95rem',
            marginRight: '8px',
            color: '#455A64',
          }}
        />
        <Typography
          variant="body2"
          sx={{ flexGrow: 1, fontSize: '0.85rem', color: '#455A64' }}
        >
          Asset type
        </Typography>
      </Box>
    </DraggablePreviewWrapper>
  );
};

export default AssetTypeFieldPreview;
